import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.regexp.split.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as types from './types';
import LOGS from '~/const/errorsLog';
import USE_MERCURE from '~/const/mercure';
import { isValidToken } from '~/helpers/connection-helper';
import { encodeSha256 } from '~/helpers/crypto-helper';
import logout from '~/helpers/logout-helper';
import { createCart, fetchCart, fetchCartTotalQuantity, addCart, updateCart, addCartCustomizable, addGiftCardToCart, addSellerIdToCart } from '~/services/cart';
import { fetchCustomerCart, addCustomerCart, addCustomerCartCustomizable, updateCustomerCart } from '~/services/customer';
var formatCustomerCartQuantity = data => {
  var qty = data.split('|').find(a => a.includes('item_qty'));
  qty = qty ? qty.replace('item_qty:', '') : 0;
  return parseInt(qty, 10) || 0;
};
var getGraphQLErrorsCode = err => {
  if (err && err.length) {
    return err[0].extensions.code || '';
  }
  return '';
};
var initCart = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (context) {
    sessionStorage.removeItem('MDM_CART_ADDRESSES');
    sessionStorage.removeItem('MDM_CART_PHONE');
    sessionStorage.removeItem('MDM_RESTORE_CART');
    sessionStorage.removeItem('MDM_CC_ELIGIBLE');
    var {
      createNewCart
    } = yield createCart(context, localStorage.getItem('MDM_ACCESS_TOKEN'));
    if (!createNewCart) {
      throw new Error('MDM_CART_CANNOT_CREATE_TOKEN');
    }
    localStorage.setItem('MDM_CART_TOKEN', createNewCart);
    return createNewCart; // cartToken: String
  });
  return function initCart(_x) {
    return _ref.apply(this, arguments);
  };
}();
export default {
  createCart() {
    var _this = this;
    return _asyncToGenerator(function* () {
      try {
        var cartToken = yield initCart(_this);
        return cartToken;
      } catch (e) {
        _this.$logger.error('CREATE CART FAILED', e);
      }
    })();
  },
  fetchCart(_ref2) {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      var {
        commit
      } = _ref2;
      var user = _this2.getters['user/me'];
      var cart = null;
      var quantity = null;
      try {
        if (USE_MERCURE(_this2.getters['i18n/locale'].iso)) {
          if (!localStorage.getItem('MDM_CART_TOKEN')) return;
          var {
            data: {
              minicart
            },
            errors
          } = yield fetchCart(_this2, {
            reference: localStorage.getItem('MDM_CART_TOKEN'),
            token: localStorage.getItem('MDM_ACCESS_TOKEN')
          });
          if (errors) {
            var code = getGraphQLErrorsCode(errors);
            if (code === 'MERCURE_ERROR_CART_NOTFOUND') {
              localStorage.removeItem('MDM_CART_TOKEN');
            }
            throw new Error(errors);
          }
          cart = minicart.items;
          quantity = minicart.quantity;
          commit(types.SET_CART_STATE, 'SUCCESS');
        } else {
          localStorage.removeItem('MDM_CART_TOKEN');
          var data = yield fetchCustomerCart(_this2);
          quantity = data.cart;
          if (data && data.user) {
            localStorage.setItem('MDM_MAILS', {
              type_A: data.user.user_email,
              type_B: encodeSha256(user.email)
            });
          }
        }
      } catch (error) {
        _this2.$logger.error(error);
        commit(types.SET_CART_STATE, 'ERROR');
      } finally {
        commit(types.SET_CART, cart);
        commit(types.SET_CART_QTY, quantity);
      }
    })();
  },
  fetchCartTotalQuantity(_ref3) {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      var {
        commit
      } = _ref3;
      var quantity = null;
      try {
        if (USE_MERCURE(_this3.getters['i18n/locale'].iso)) {
          if (!localStorage.getItem('MDM_CART_TOKEN')) return;
          var {
            data,
            errors
          } = yield fetchCartTotalQuantity(_this3, {
            reference: localStorage.getItem('MDM_CART_TOKEN'),
            token: localStorage.getItem('MDM_ACCESS_TOKEN')
          });
          if (errors) {
            var code = getGraphQLErrorsCode(errors);
            if (code === 'MERCURE_ERROR_CART_NOTFOUND') {
              localStorage.removeItem('MDM_CART_TOKEN');
            }
            throw new Error(errors);
          }
          quantity = data.cartTotalQuantity;
          commit(types.SET_CART_STATE, 'SUCCESS');
        } else {
          localStorage.removeItem('MDM_CART_TOKEN');
          var _data = yield fetchCustomerCart(_this3);
          quantity = _data.cartTotalQuantity;
        }
      } catch (error) {
        _this3.$logger.error(error);
        commit(types.SET_CART_STATE, 'ERROR');
      } finally {
        commit(types.SET_CART_QTY, quantity);
      }
    })();
  },
  addGiftCard(_ref4, _ref5) {
    var _this4 = this;
    return _asyncToGenerator(function* () {
      var {
        commit
      } = _ref4;
      var {
        context,
        senderName,
        recipientName,
        recipientEmail,
        price,
        design,
        message,
        recaptchaToken
      } = _ref5;
      try {
        var _localStorage$getItem;
        if (localStorage.getItem('MDM_ACCESS_TOKEN') && !isValidToken()) {
          yield logout(_this4.$store);
        }
        if (!localStorage.getItem('MDM_CART_TOKEN')) {
          yield initCart(_this4);
        }
        var {
          errors
        } = yield addGiftCardToCart(context.$apolloProvider, {
          cart: localStorage.getItem('MDM_CART_TOKEN'),
          senderName,
          recipientName,
          recipientEmail,
          price,
          design,
          message,
          token: (_localStorage$getItem = localStorage.getItem('MDM_ACCESS_TOKEN')) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : null,
          recaptchaToken
        });
        if (errors) {
          throw errors;
        }
        var quantity = _this4.getters['cart/total'] + 1;
        commit(types.SET_CART_QTY, quantity);
        commit(types.SET_CART_SUCCESS, true);
      } catch (e) {
        _this4.$logger.customFilter(e, LOGS.ADD_GIFT_CART);
        throw e;
      }
    })();
  },
  add(_ref6, payload) {
    var _this5 = this;
    return _asyncToGenerator(function* () {
      var {
        commit,
        state
      } = _ref6;
      var cart = state.items;
      var quantity = state.total;
      var isError = false;
      try {
        var item = state.items ? state.items.find(p => p.productReference === payload.reference) : {};
        var maxQuantityReached = item && item.quantity >= 30;
        if (USE_MERCURE(_this5.getters['i18n/locale'].iso)) {
          if (localStorage.getItem('MDM_ACCESS_TOKEN') && !isValidToken()) {
            yield logout(_this5.$store);
          }
          if (!localStorage.getItem('MDM_CART_TOKEN')) {
            yield initCart(_this5);
          }
          if (!maxQuantityReached) {
            var {
              data: {
                addProductsToCart
              },
              errors
            } = yield addCart(_this5, _objectSpread({
              cart: localStorage.getItem('MDM_CART_TOKEN'),
              token: localStorage.getItem('MDM_ACCESS_TOKEN')
            }, payload));
            if (errors) {
              commit(types.SET_CART_SUCCESS_SERVER, false);
              throw new Error(errors[0].message);
            }
            cart = addProductsToCart.items;
            quantity = addProductsToCart.quantity;
          } else {
            var totalQuantity = state.items.reduce((acc, pdt) => acc + pdt.quantity, 0);
            cart = state.items;
            quantity = totalQuantity;
          }
        } else {
          var data = yield addCustomerCart(_this5, payload);
          var currentTotal = state.total;
          cart = [{
            reference: payload.reference,
            productReference: payload.reference,
            quantity: formatCustomerCartQuantity(data)
          }];
          quantity = currentTotal + 1;
        }
      } catch (error) {
        isError = true;
        if (!error.message || !error.message.includes('GraphQL error')) {
          commit(types.SET_CART_SUCCESS_SERVER, false);
        }
        commit(types.SET_CART_SUCCESS, false);
        _this5.$logger.error(error);
      } finally {
        if (!isError) {
          commit(types.SET_CART, cart);
          commit(types.SET_CART_QTY, quantity);
          commit(types.SET_CART_SUCCESS, true);
          commit(types.SET_CART_SUCCESS_SERVER, true);
        }
      }
    })();
  },
  update(_ref7, payload) {
    var _this6 = this;
    return _asyncToGenerator(function* () {
      var {
        commit
      } = _ref7;
      var cart = null;
      var quantity = null;
      var reference = null;
      var items = _this6.state.cart.items.filter(e => e.productReference === payload.reference);
      if (items.length > 1) {
        reference = items.find(e => e.offer === payload.offer).reference;
      } else {
        reference = items[0].reference;
      }
      try {
        if (USE_MERCURE(_this6.getters['i18n/locale'].iso)) {
          var {
            updateCartItems
          } = yield updateCart(_this6, {
            cart: localStorage.getItem('MDM_CART_TOKEN'),
            token: localStorage.getItem('MDM_ACCESS_TOKEN'),
            quantity: payload.quantity,
            reference
          });
          cart = updateCartItems.items;
          quantity = updateCartItems.quantity;
        } else {
          var data = yield updateCustomerCart(_this6, payload);
          cart = [{
            reference: payload.reference,
            productReference: payload.reference,
            quantity: data.cartItem
          }];
          var response = yield fetchCustomerCart(_this6);
          quantity = response.cart;
        }
      } catch (error) {
        commit(types.SET_CART_SUCCESS, false);
        _this6.$logger.error(error);
      } finally {
        commit(types.SET_CART, cart);
        commit(types.SET_CART_QTY, quantity);
        commit(types.SET_CART_SUCCESS, true);
      }
    })();
  },
  addCartCustomizable(_ref8, payload) {
    var _this7 = this;
    return _asyncToGenerator(function* () {
      var {
        state,
        commit
      } = _ref8;
      var currentTotal = state.total;
      try {
        if (USE_MERCURE(_this7.getters['i18n/locale'].iso)) {
          if (localStorage.getItem('MDM_ACCESS_TOKEN') && !isValidToken()) {
            yield logout(_this7.$store);
          }
          if (!localStorage.getItem('MDM_CART_TOKEN')) {
            yield initCart(_this7);
          }
          var {
            addCustomizableProductToCart
          } = yield addCartCustomizable(_this7, {
            cart: localStorage.getItem('MDM_CART_TOKEN'),
            token: localStorage.getItem('MDM_ACCESS_TOKEN'),
            payload
          });
          commit(types.SET_CART_QTY, currentTotal + 1);
          commit(types.SET_CART, addCustomizableProductToCart.items);
          commit(types.SET_CART_SUCCESS, true);
        } else {
          var data = yield addCustomerCartCustomizable(_this7, payload);
          if (data.success) {
            commit(types.SET_CART_QTY, currentTotal + 1);
            commit(types.SET_CART_SUCCESS, true);
          } else {
            commit(types.SET_CART_SUCCESS, false);
          }
        }
      } catch (error) {
        commit(types.SET_CART_SUCCESS, false);
        _this7.$logger.error(error);
      }
    })();
  },
  setSellerIdToCart(_ref9, _ref10) {
    var _this8 = this;
    return _asyncToGenerator(function* () {
      var {
        commit
      } = _ref9;
      var {
        cartToken,
        sellerId
      } = _ref10;
      try {
        var token = localStorage.getItem('MDM_ACCESS_TOKEN');
        var {
          seller_id: sellerIdOutput
        } = yield addSellerIdToCart(_this8, {
          cartToken,
          sellerId,
          token
        });
        commit(types.SET_CART_SELLER_ID, sellerIdOutput);
      } catch (e) {
        _this8.$logger.error('BIND SELLER ID TO CART FAILED', e);
      }
    })();
  }
};